import { SessionState } from "../session.slice.ts";
import { PayloadAction } from "@reduxjs/toolkit";
import { SessionStateEnum } from "../../../../orchestrator-api-client";

export default function setSessionStateReducer(
  state: SessionState,
  action: PayloadAction<SessionStateEnum>,
) {
  state.state = action.payload;
}
